import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class AttributeRequirementsDecimal
*  Настройки атрибута со значением в виде десятичного числа
*/
export class AttributeRequirementsDecimal extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'Decimal' })
  readonly type: string = 'Decimal'


  /**
  * minValue
  * Минимальное допустимое значение  */
  @ActiveField()
  minValue?: null | number


  /**
  * maxValue
  * Максимальное допустимое значение  */
  @ActiveField()
  maxValue?: null | number


  /**
  * maxPrecision
  * Максимальное кол-во цифр в десятичной части  */
  @ActiveField()
  maxPrecision?: null | number
}
